import type { MemberFields } from '../components/add-member-form';

export const EMPTY_MEMBER_DATA: MemberFields = {
  firstName: '',
  lastName: '',
  type: undefined,
  username: '',
};
